class CustaDestinatario {
  constructor (data) {
    this.custa_item_id = null
    this.custa_id = null
    this.destino = null
    this.flag_averbacao = null
    this.valor = null  
    this.created_at = null
    this.updated_at = null   

    if (data) this.__init(data)
  }

  __init (data) {
    Object.assign(this, data)
    if (data.valor === null) this.valor = 0
  }
}

export default CustaDestinatario